module.exports = __webpack_public_path__ + "static/assets/30dc15954cbf901521805bd37077daa2.svg";